import { IOpData } from '../util/interfaces'
import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'
import { ConvertHelper } from '../../helpers'


export class OpPackageData implements IOpData {

    //#region Properties

    public idPackageData: number
    public idPackage: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //#endregion


    //#region NavigationProperties

    public dataType: OpDataType

    //#endregion NavigationProperties end

    //#region Ctor

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //#endregion

    //#region IOpData implementation

    public get idData() { return this.idPackageData }
    public get indexNBR() { return this.indexNbr }

    //#endregion IOpData implementation end


    //#region IOpChangeState implementation

    public opState: Enums.OpChangeState

    //#endregion IOpChangeState implementation end


    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idPackageData = opObj.ID_PACKAGE_DATA
            this.idPackage = opObj.ID_PACKAGE
            this.idDataType = opObj.ID_DATA_TYPE
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE

            if (opObj.VALUE) {
                if (opObj.VALUE.toString().indexOf('/Date(') === 0) {
                    this.value = ConvertHelper.stringToDate(opObj.VALUE)
                }
            }

            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_OPERATOR_DATA: this.idPackageData,
            ID_OPERATOR: this.idPackage,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }

    public static fromIOpData(data: IOpData): OpPackageData {
        const newData: OpPackageData = new OpPackageData(null)

        newData.idPackageData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}